/* unplugin-vue-components disabled */import script from "./MaterialHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialHistory.vue?vue&type=script&setup=true&lang=js"

import "./MaterialHistory.vue?vue&type=style&index=0&id=5fa3e52e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa3e52e"]])

export default __exports__